<template>
  <b class="text-success">
    (
    <slot>automatycznie</slot>)
  </b>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>